import { useMemo } from 'react';
import { useUserStore } from '@/state/user.state';
import { CreditsType } from '@/types/auth.types';
import { SubscriptionType } from '@/types/shared';

export const useSubscriptionCredits = () => {
  const subscription = useUserStore((state) => state.user?.activeWorkspace.subscription);
  const isEnterpriseSubscription = subscription?.type === SubscriptionType.Enterprise;

  const availableMonthlyCredits = useMemo(() => {
    return subscription?.creditsList?.find((credit) => credit.type === CreditsType.Monthly)?.available;
  }, [subscription?.creditsList]);

  const monthlyCreditsAllocation = useMemo(() => {
    return subscription?.creditsList?.find((credit) => credit.type === CreditsType.Monthly)?.allocatedAmount;
  }, [subscription?.creditsList]);

  const totalExtraCredits = useMemo(() => {
    const extraCredits = subscription?.creditsList?.filter((credit) => credit.type === CreditsType.Extra);

    // if no active extra credits - don't show
    if (!extraCredits?.length) {
      return;
    }

    return extraCredits.reduce((acc, credit) => {
      return acc + credit.available;
    }, 0);
  }, [subscription?.creditsList]);

  const totalRolloverCredits = useMemo(() => {
    const rolloverCredits = subscription?.creditsList?.filter((credit) => credit.type === CreditsType.Rollover);
    if (!rolloverCredits?.length) {
      return;
    }

    return rolloverCredits.reduce((acc, credit) => {
      return acc + credit.available;
    }, 0);
  }, [subscription?.creditsList]);

  return {
    availableMonthlyCredits,
    monthlyCreditsAllocation,
    totalExtraCredits,
    totalRolloverCredits,
    isEnterpriseSubscription,
  };
};
